import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';

import { useLocation } from "react-router";


import rajVoice from "../assets/rahulVoice.mp4";
import sukhVinderVoice from "../assets/sukhVinderVoice.mp4";
import sukhVinderNoVoice from "../assets/sukhvinderNoVoice.mp4";

import rajNoVoice from "../assets/rahulNoVoice.mp4";

import { EchoSessionData, Question, Transcript } from "../types/echo-session";
import ApiService from "../service/api-service";
import { EchoLanguage } from "../types/echo";

// TypeScript declarations for Web Speech API
interface SpeechRecognitionEvent extends Event {
    results: SpeechRecognitionResultList;
  }
  
  interface SpeechRecognitionResultList {
    length: number;
    item(index: number): SpeechRecognitionResult;
    [index: number]: SpeechRecognitionResult;
  }
  
  interface SpeechRecognitionResult {
    isFinal: boolean;
    [index: number]: SpeechRecognitionAlternative;
  }
  
  interface SpeechRecognitionAlternative {
    transcript: string;
    confidence: number;
  }
  
  interface SpeechRecognition extends EventTarget {
    lang: string;
    continuous: boolean;
    interimResults: boolean;
    start(): void;
    stop(): void;
    onstart: (event: Event) => void;
    onend: (event: Event) => void;
    onresult: (event: SpeechRecognitionEvent) => void;
  }
  
  // Add AudioContext type
  declare global {
    interface Window {
      SpeechRecognition: new () => SpeechRecognition;
      webkitSpeechRecognition: new () => SpeechRecognition;
      webkitAudioContext: typeof AudioContext;
    }
  }

  const OneToOneMeeting: React.FC = () => {
    const navigate = useNavigate();
    // Constants for timeout durations
  const INITIAL_RESPONSE_TIMEOUT_MS = 15000; // 15 seconds to start speaking
  const SILENCE_TIMEOUT_MS = 7000; // 7 seconds of silence to end
  

  const mainVideoRef = useRef<HTMLVideoElement>(null);
  const [isCallActive, setIsCallActive] = useState(true);
  const [showCompletionScreen, setShowCompletionScreen] = useState(false);
  const [userResponse, setUserResponse] = useState("");
  const recognitionRef = useRef<SpeechRecognition | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);

  const [initialTimer, setInitialTimer] = useState<number>(-1);
  const [startAnswerTimer, setStartAnswerTimer] = useState<number>(15);
  const [displayInitialTimer, setDisplayInitialTimer] = useState<boolean>(false);
  const [displayStartAnswerTimer, setDisplayStartAnswerTimer] = useState<boolean>(false);

  const [submittingAnswer, setSubmittingAnswer] = useState<boolean>(false);

  const submittingAnswerRef = useRef<{submittingAnswer: boolean}>({submittingAnswer: false});

  const [submitAnswerVisible, setSubmitAnswerVisible] = useState<boolean>(false);

  const submitAnswerVisibleRef = useRef<{submitAnswerVisible: boolean}>({submitAnswerVisible: false});

  const timerRef = useRef<{initialTimer: number, startAnswerTimer: number, displayInitialTimer: boolean, intialTimerInProgress: boolean, displayStartAnswerTimer: boolean}>({initialTimer: -1, startAnswerTimer: 15, displayInitialTimer: false, intialTimerInProgress: false, displayStartAnswerTimer: false});

  const answerTwoMinutesTimerRef = useRef<{answerTwoMinutesTimer: number, displayAnswerTwoMinutesTimer: boolean}>({answerTwoMinutesTimer: 120, displayAnswerTwoMinutesTimer: false});
  const [answerTwoMinutesTimer, setAnswerTwoMinutesTimer] = useState<number>(120);
  const [displayAnswerTwoMinutesTimer, setDisplayAnswerTwoMinutesTimer] = useState<boolean>(false);

  const [isVoicePlaying, setIsVoicePlaying] = useState<boolean>(false);
  const isVoicePlayingRef = useRef<boolean>(false);

  const [submitAnswerLoading, setSubmitAnswerLoading] = useState<boolean>(false);
  const allTranscripts = useRef<{role: "ASSISTANT" | "USER", content: string, audio_url: string, id: string, isFirstFeedback: boolean, isFollowUp: boolean, previousQuestion: string, previousMasterQuestion: string, recordingKey: string, recordingWriteUrl: string}[]>([]);
  const [transcripts, setTranscripts] = useState<{role: "ASSISTANT" | "USER", content: string, audio_url: string, id: string, isFirstFeedback: boolean, isFollowUp: boolean, previousQuestion: string, previousMasterQuestion: string, recordingKey: string, recordingWriteUrl: string}[]>([]);

  const answerStartTimerRef = useRef<{answerStartTimer: number}>({answerStartTimer: 0});
  const answerStartTimerIntervalRef = useRef<Date>(new Date());
  const [answerStartTimer, setAnswerStartTimer] = useState<number>(0);
  

  const userResponseRef = useRef({userResponse: ""});

  const streamRef = useRef<MediaStream | null>(null);
  const transcriptsEndRef = useRef<HTMLDivElement | null>(null);

  // Speech recognition setup
  const setupSpeechRecognition = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    let twoMinInterval: NodeJS.Timeout | null = null;
    
    recognition.onstart = () => {
      mediaRecorderRef.current?.start();
      if(timeoutRef.current) {
        console.log("CLEARING TIMEOUT 0");
        clearTimeout(timeoutRef.current);
      }
      answerTwoMinutesTimerRef.current.answerTwoMinutesTimer = 120;
      answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer = true;
      setDisplayAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer);
      setAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer);
      twoMinInterval = setInterval(() => {
        answerTwoMinutesTimerRef.current.answerTwoMinutesTimer = answerTwoMinutesTimerRef.current.answerTwoMinutesTimer - 1;
        setAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer);
        console.log(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer);
        if(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer <= 0) {
          console.log("STOPPING RECOGNITION FROM TWO MINUTE INTERVAL");
          recognition.stop();
          if (twoMinInterval) clearInterval(twoMinInterval);
          answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer = false;
          setDisplayAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer);
          answerTwoMinutesTimerRef.current.answerTwoMinutesTimer = 120;
          setAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer);
        }
      }, 1000);

      answerStartTimerIntervalRef.current = new Date();
      console.log("Speech recognition started");
      
     
    };

    recognition.onresult = (event) => {
      timerRef.current.intialTimerInProgress = false;
      const transcript = Array.from(event.results)
        .map(result => result[0].transcript)
        .join("");
      setUserResponse(transcript);
      userResponseRef.current.userResponse = transcript;
      
      // Reset the timeout when user speaks
      if (timeoutRef.current) {
        console.log("CLEARING TIMEOUT 1");
        clearTimeout(timeoutRef.current);
      }

      if(intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer <= 0) {
        console.log("STOPPING RECOGNITION FROM TWO MINUTE INTERVAL 2");
        recognition.stop();
        if (twoMinInterval) clearInterval(twoMinInterval);
        return;
      }
      timerRef.current.startAnswerTimer = 7;
      timerRef.current.displayStartAnswerTimer = false;
      setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
      setStartAnswerTimer(timerRef.current.startAnswerTimer);

      intervalRef.current = setInterval(() => {
        if(!answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer) {
          return;
        }
        timerRef.current.startAnswerTimer = timerRef.current.startAnswerTimer - 1;
        setStartAnswerTimer(timerRef.current.startAnswerTimer);

        if(timerRef.current.startAnswerTimer <= 5 && timerRef.current.displayInitialTimer == false) {
         timerRef.current.displayStartAnswerTimer = true;
         setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
        }
        if(timerRef.current.startAnswerTimer <= 0) {
          if (intervalRef.current) clearInterval(intervalRef.current);
          timerRef.current.displayStartAnswerTimer = false;
          setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
        }
      }, 1000);
      

      
      
      // Set new timeout for pause detection
      timeoutRef.current = setTimeout(() => {
        
        if (recognition && timerRef.current.displayStartAnswerTimer) {
          console.log("STOPPING RECOGNITION FROM 7 SECONDS");
          recognition.stop();
          if (twoMinInterval) clearInterval(twoMinInterval);
        }
      }, SILENCE_TIMEOUT_MS);
    };

    recognition.onend = async () => {
      mediaRecorderRef.current?.stop();
      console.log("RECOGNITION ENDED");
      if(timerRef.current.intialTimerInProgress) {
        console.log("RESTARTING RECOGNITION");
        recognition.start();
        return;
      }

      if(twoMinInterval) {
        console.log("CLEARING TWO MINUTE INTERVAL");
        clearInterval(twoMinInterval);
        answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer = false;
        setDisplayAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer);
        answerTwoMinutesTimerRef.current.answerTwoMinutesTimer = 120;
        setAnswerTwoMinutesTimer(answerTwoMinutesTimerRef.current.answerTwoMinutesTimer);
      }
      submitAnswerVisibleRef.current.submitAnswerVisible = false;
      setSubmitAnswerVisible(submitAnswerVisibleRef.current.submitAnswerVisible);
      timerRef.current.displayStartAnswerTimer = false;
      setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
      timerRef.current.startAnswerTimer = 7;
      setStartAnswerTimer(timerRef.current.startAnswerTimer);
      
      // Stop audio recording and save the file
      
      
        console.log("Stopping audio recording");
        // const lastQuestionByInterviewer = allTranscripts.current.filter(transcript => transcript.role === "ASSISTANT").pop();
        const lastQuestionByInterviewer = allTranscripts.current.filter(transcript => transcript.role === "ASSISTANT").pop();
       const timeTakenTopRespondInSeconds = (new Date().getTime() - answerStartTimerIntervalRef?.current?.getTime() || 0) / 1000;
        
          submittingAnswerRef.current.submittingAnswer = true;
          setSubmittingAnswer(submittingAnswerRef.current.submittingAnswer);
          setSubmitAnswerLoading(true);
        
        
          const submitFeedbackResponse = await ApiService.submitFeedback(response?.session?.echoId || "", response?.session?.audienceId || "", userResponseRef.current.userResponse, lastQuestionByInterviewer?.isFirstFeedback || false, lastQuestionByInterviewer?.previousQuestion || "", lastQuestionByInterviewer?.previousMasterQuestion || "", timeTakenTopRespondInSeconds, lastQuestionByInterviewer?.recordingKey || "", lastQuestionByInterviewer?.recordingWriteUrl || "");
            setSubmitAnswerLoading(false);
          submittingAnswerRef.current.submittingAnswer = false;
          setSubmittingAnswer(submittingAnswerRef.current.submittingAnswer);
          answerStartTimerIntervalRef.current = new Date();
        
          
          
          setUserResponse("");
          allTranscripts.current.push({
            role: "USER", 
            content: submitFeedbackResponse.data.transcript[0].transcript || "", 
            audio_url: "",
            id: "",
            isFollowUp: false,
            isFirstFeedback: submitFeedbackResponse.data.isFirstFeedback || false,
            previousMasterQuestion: submitFeedbackResponse.data.previousMasterQuestion || "",
            previousQuestion: "",
            recordingKey: response?.recordingKey || "",
            recordingWriteUrl: response?.recordingWriteUrl || ""
          });
          setTranscripts(allTranscripts.current);
          userResponseRef.current.userResponse = "";
        console.log(submitFeedbackResponse.data, "IS SESSION END");
        console.log(submitFeedbackResponse?.data?.isSessionEnded, "IS SESSION ENDED");
        if(submitFeedbackResponse?.data?.isSessionEnded) {
          console.log("SESSION ENDED");
          await endInterview(submitFeedbackResponse?.data?.question?.[0]?.audio || "", submitFeedbackResponse?.data?.question?.[0]?.id || "", submitFeedbackResponse?.data?.question?.[0]?.question || "");
          
        }
        else {
          playNextAnswerAudioSequentially(submitFeedbackResponse?.data);
        }
          console.log("Speech recognition ended");
        
      
    };
    recognition.lang = response.language === EchoLanguage.HINDI ? 'hi-IN' : response.language === EchoLanguage.ENGLISH ? 'en-IN' : response.language === EchoLanguage.MARATHI ? 'mr-IN' : response.language === EchoLanguage.BENGALI ? 'bn-IN' : response.language === EchoLanguage.PUNJABI ? 'pa-IN'  : 'en-IN';
    recognitionRef.current = recognition;
  };



  const {response} = useLocation().state as {response: EchoSessionData};

  useEffect(() => {
    setupSpeechRecognition();
    return () => {
      if (timeoutRef.current) {
        console.log("CLEARING TIMEOUT 3");
        clearTimeout(timeoutRef.current);
      }
      if (recognitionRef.current) {
        console.log("STOPPING RECOGNITION FROM USEFFECT");
        recognitionRef.current.stop();
      }
    };
  }, []);

  useEffect(() => {
    // Ensure smooth scrolling to bottom when transcripts or loading state changes
    const scrollToBottom = () => {
      if (transcriptsEndRef.current) {
        transcriptsEndRef.current.scrollIntoView({ 
          behavior: "smooth",
          block: "end",
          inline: "nearest"
        });
      }
    };

    // Add a small delay to ensure DOM is updated
    const timeoutId = setTimeout(scrollToBottom, 100);

    return () => clearTimeout(timeoutId);
  }, [transcripts, submitAnswerLoading]);

  // TODO: UPDATE THE END INTERVIEW LOGIC
  const endInterview = async (audioUrl: string, id: string, content: string) => {
    await playBase64Audio(audioUrl, isVoicePlayingRef, setIsVoicePlaying);
    console.log("Ending interview", audioUrl, id, content);
    mediaRecorderRef.current?.stop();
    setTimeout(() => {
      navigate('/interview-complete', { replace: true });
    }, 1000);
  }

  const playBase64Audio = async (base64Audio: string, isVoicePlayingRef: React.RefObject<boolean>, setIsVoicePlaying: React.Dispatch<React.SetStateAction<boolean>>) => {
    console.log("Playing base64 audio", base64Audio);
    return new Promise((resolve, reject) => {
      try {
        // Convert base64 to audio buffer
        const audio = new Audio();
        audio.src = `data:audio/mp3;base64,${base64Audio}`;

        audio.onplay = () => {
          isVoicePlayingRef.current = true;
          setIsVoicePlaying(isVoicePlayingRef.current);
        };

        audio.onended = () => {
          isVoicePlayingRef.current = false;
          setIsVoicePlaying(isVoicePlayingRef.current);
          resolve(true);
        };

        audio.onerror = (error) => {
          console.error("Audio playback error:", error);
          isVoicePlayingRef.current = false;
          setIsVoicePlaying(isVoicePlayingRef.current);
          reject(error);
        };

        // Try to play and handle autoplay restriction error
        audio.play().catch((error) => {
          console.warn("Autoplay prevented:", error);
          
          // Create a user interaction requirement
          const playButton = document.createElement('button');
          playButton.textContent = 'Click to Start Audio';
          playButton.className = 'fixed top-4 left-1/2 transform -translate-x-1/2 bg-teal-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 cursor-pointer hover:bg-teal-600 transition-colors';
          
          playButton.onclick = async () => {
            try {
              await audio.play();
              playButton.remove();
            } catch (err) {
              console.error("Failed to play audio after user interaction:", err);
              reject(err);
            }
          };
          
          document.body.appendChild(playButton);
        });
      } catch (error) {
        console.error("Audio setup error:", error);
        isVoicePlayingRef.current = false;
        setIsVoicePlaying(isVoicePlayingRef.current);
        reject(error);
      }
    });
  };

  const playNextAnswerAudioSequentially = async (session: EchoSessionData) => {
    for(let i = 0; i < session.question.length; i++) {
     allTranscripts.current.push({role: "ASSISTANT", content: session.question[i].question, audio_url: session.question[i].audio, id: session.question[i].id, isFollowUp: false, isFirstFeedback: session.isFirstFeedback, previousMasterQuestion: session.previousMasterQuestion, previousQuestion: session.previousQuestion, recordingKey: session.recordingKey || "", recordingWriteUrl: session.recordingWriteUrl || ""});
     setTranscripts(allTranscripts.current);
      await playBase64Audio(session.question[i].audio, isVoicePlayingRef, setIsVoicePlaying);
      await new Promise(resolve => setTimeout(resolve, 100));
    }


    submitAnswerVisibleRef.current.submitAnswerVisible = true;
    setSubmitAnswerVisible(submitAnswerVisibleRef.current.submitAnswerVisible);

    if (recognitionRef.current) {        
      console.log("Starting recognition");
      setStartAnswerTimer(15);
      timerRef.current.initialTimer = 15;
      timerRef.current.displayInitialTimer = true;
      timerRef.current.displayStartAnswerTimer = false;
      setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
      setDisplayInitialTimer(timerRef.current.displayInitialTimer);
      timerRef.current.intialTimerInProgress = true;
      timerRef.current.displayInitialTimer = true;
      timerRef.current.displayStartAnswerTimer = false;
      setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
      recognitionRef.current.start();
      submitAnswerVisibleRef.current.submitAnswerVisible = true;
      setSubmitAnswerVisible(submitAnswerVisibleRef.current.submitAnswerVisible);
      const interval = setInterval(() => {
        if(timerRef.current.intialTimerInProgress == false) {
          clearInterval(interval);
          timerRef.current.displayInitialTimer = false;
          setDisplayInitialTimer(timerRef.current.displayInitialTimer);
          timerRef.current.displayInitialTimer = false;
          timerRef.current.intialTimerInProgress = false;
          return;
        }
        console.log(timerRef.current.initialTimer);
        timerRef.current.initialTimer = timerRef.current.initialTimer - 1;
        setInitialTimer(timerRef.current.initialTimer);
        if(timerRef.current.initialTimer === 0) {
          clearInterval(interval);
          timerRef.current.displayInitialTimer = false;
          setDisplayInitialTimer(timerRef.current.displayInitialTimer);
          timerRef.current.displayInitialTimer = false;
          timerRef.current.displayStartAnswerTimer = false;
          setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
          timerRef.current.intialTimerInProgress = false;
        }
      }, 1000);
      
      // Set timeout for initial response
      timeoutRef.current = setTimeout(() => {
        if(!timerRef.current.displayInitialTimer) {
          console.log("STOPPING RECOGNITION FROM 15 SECONDS");
          if (recognitionRef.current) {
            recognitionRef.current.stop();
          }
        }
      }, INITIAL_RESPONSE_TIMEOUT_MS); // Wait 15 seconds for user to start speaking
    }
    
  }

  useEffect(() => {
    
    const playAudioSequentially = async () => {
      if (response?.transcript[0]?.transcript) {
        console.log(response.transcript[0].transcript, "THIS IS THE CONTENT TO SPEAK");
        setTranscripts((prev) => [...prev, {role: "ASSISTANT", content: response.question[0].question, audio_url: response.question[0].audio, id: response.question[0].id, isFollowUp: false, isFirstFeedback: response.isFirstFeedback, previousMasterQuestion: response.previousMasterQuestion, previousQuestion: response.previousQuestion, recordingKey: response.recordingKey || "", recordingWriteUrl: response.recordingWriteUrl || ""}]);
        allTranscripts.current.push({role: "ASSISTANT", content: response.question[0].question, audio_url: response.question[0].audio, id: response.question[0].id, isFollowUp: false, isFirstFeedback: response.isFirstFeedback, previousMasterQuestion: response.previousMasterQuestion, previousQuestion: response.previousQuestion, recordingKey: response.recordingKey || "", recordingWriteUrl: response.recordingWriteUrl || ""});
        await playBase64Audio(response.question[0].audio, isVoicePlayingRef, setIsVoicePlaying);
      }

      if (recognitionRef.current) {        
        console.log("Starting recognition");
        setStartAnswerTimer(15);
        timerRef.current.initialTimer = 15;
        timerRef.current.displayInitialTimer = true;
        timerRef.current.displayStartAnswerTimer = false;
        setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
        setDisplayInitialTimer(timerRef.current.displayInitialTimer);
        timerRef.current.intialTimerInProgress = true;
        timerRef.current.displayInitialTimer = true;
        timerRef.current.displayStartAnswerTimer = false;
        setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
        recognitionRef.current.start();
        submitAnswerVisibleRef.current.submitAnswerVisible = true;
        setSubmitAnswerVisible(submitAnswerVisibleRef.current.submitAnswerVisible);
        const interval = setInterval(() => {
          if(timerRef.current.intialTimerInProgress == false) {
            clearInterval(interval);
            timerRef.current.displayInitialTimer = false;
            setDisplayInitialTimer(timerRef.current.displayInitialTimer);
            timerRef.current.displayStartAnswerTimer = false;
            setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
            timerRef.current.displayInitialTimer = false;
            timerRef.current.intialTimerInProgress = false;
            return;
          }
          console.log(timerRef.current.initialTimer);
          timerRef.current.initialTimer = timerRef.current.initialTimer - 1;
          setInitialTimer(timerRef.current.initialTimer);
          if(timerRef.current.initialTimer === 0) {
            clearInterval(interval);
            timerRef.current.displayInitialTimer = false;
            setDisplayInitialTimer(timerRef.current.displayInitialTimer);
            timerRef.current.displayInitialTimer = false;
            timerRef.current.displayStartAnswerTimer = false;
            setDisplayStartAnswerTimer(timerRef.current.displayStartAnswerTimer);
            timerRef.current.intialTimerInProgress = false;
          }
        }, 1000);
        
        // // Set timeout for initial response
        // timeoutRef.current = setTimeout(() => {
        //   if(!timerRef.current.displayInitialTimer) {
        //     console.log("Stopping recognition in 15 seconds");
        //     if (recognitionRef.current) {
        //       recognitionRef.current.stop();
        //     }
        //   }
        // }, INITIAL_RESPONSE_TIMEOUT_MS); // Wait 15 seconds for user to start speaking
      }
    };
    setTimeout(() => {
      playAudioSequentially();
    }, 1000);
  }, []);

  useEffect(() => {
    if (!isCallActive) {
      stopMediaTracks();
      setShowCompletionScreen(true);
    }
  }, [isCallActive]);

  const stopMediaTracks = () => {
    if (streamRef.current) {
      
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  useEffect(() => {
    const startVideo = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        
        if (mainVideoRef.current) {
          mainVideoRef.current.srcObject = mediaStream;
        }
        streamRef.current = mediaStream;
        if (streamRef.current) {
          audioChunksRef.current = [];
          const mediaRecorder = new MediaRecorder(streamRef.current, {
            mimeType: 'video/webm;codecs=vp9'
          });
          mediaRecorderRef.current = mediaRecorder;

          mediaRecorder.onstart = (e) => {
            console.log("VIDEO RECORDING STARTED");
            audioChunksRef.current = [];
          }

          mediaRecorder.onstop = async (e) => {
            console.log("VIDEO RECORDING STOPPED");
            console.log(audioChunksRef.current);
            const lastQuestionByInterviewer = allTranscripts.current.filter(transcript => transcript.role === "ASSISTANT").pop();
            console.log(lastQuestionByInterviewer?.recordingKey);
            console.log(lastQuestionByInterviewer?.recordingWriteUrl);
              try {
              const fullVideo = new Blob(audioChunksRef.current, { type: 'video/webm' });
              await fetch(lastQuestionByInterviewer?.recordingWriteUrl || "", {
                method: 'PUT',
                headers: {
                  'Content-Type': 'video/webm;codecs=vp9'
                },
                body: fullVideo
              });
              console.log('Full video uploaded successfully');
            } catch (err) {
              console.error('Upload error:', err);
            }

          }
          
          mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              audioChunksRef.current.push(event.data);
            }
          };
        
          // mediaRecorder.onstop = async () => {
          //   console.log("Recording stopped, uploading full video...");
          //   try {
          //     const fullVideo = new Blob(audioChunksRef.current, { type: 'video/webm' });
          //     await fetch(response?.writeUrl || "", {
          //       method: 'PUT',
          //       headers: {
          //         'Content-Type': 'video/webm'
          //       },
          //       body: fullVideo
          //     });
          //     console.log('Full video uploaded successfully');
          //   } catch (err) {
          //     console.error('Upload error:', err);
          //   }
          // };
        }
      } catch (err) {
        console.error("Failed to access media devices:", err);
      }
    };

    startVideo();

    return () => {
      stopMediaTracks();
    };
  }, []);

  return (
    <div className="relative w-full h-screen flex flex-col md:flex-row bg-white text-white"> 
      {/* Main video (agent feed) */}
      <div className="flex-1 flex items-center justify-center relative">
        {/* Agent video container - centered */}
        
        {response.showAvatar ? (
          <>
            <video
              autoPlay
              muted
              playsInline
              loop
              className={`h-full ${isVoicePlayingRef.current ? "hidden" : "block"}`}
            >
              <source src={response.language === EchoLanguage.PUNJABI ? sukhVinderNoVoice : rajNoVoice} type="video/mp4" />
            </video>
            <video
              autoPlay
              muted
              playsInline
              loop
              className={`h-full ${isVoicePlayingRef.current ? "block" : "hidden"}`}
            >
              <source src={response.language === EchoLanguage.PUNJABI ? sukhVinderVoice : rajVoice} type="video/mp4" />
            </video>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center w-full h-full bg-gradient-to-br from-gray-900 to-gray-800 relative overflow-hidden">
            {/* Animated background pattern */}
            <div className="absolute inset-0 opacity-5">
              <div className="absolute inset-0 bg-grid-white/[0.1] bg-[length:40px_40px]"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-800/30 to-gray-900/50"></div>
            </div>
            
            {/* Main content */}
            <div className="relative z-10 flex flex-col items-center space-y-6">
              {/* Avatar circle with subtle glow */}
              <div className="relative">
                <div className="absolute -inset-2 rounded-full bg-cyan-500/10"></div>
                <div className="relative w-24 h-24 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
              </div>

              {/* Status indicator */}
              <div className="flex items-center space-x-2 bg-gray-800/50 px-4 py-2 rounded-full backdrop-blur-sm">
                <div className="w-2 h-2 rounded-full bg-green-500 opacity-80"></div>
                <span className="text-sm font-medium text-gray-200">Active Call</span>
              </div>

              {/* Call status */}
              <div className="text-xl font-medium text-gray-200 tracking-wide">
                {isVoicePlayingRef.current ? "Speaking..." : "Listening..."}
              </div>

              {/* Subtle audio indicator when speaking */}
              {isVoicePlayingRef.current && (
                <div className="flex items-center space-x-0.5 h-6 overflow-hidden">
                  {[...Array(5)].map((_, i) => (
                    <div
                      key={i}
                      className="w-1 bg-cyan-500/80 rounded-full transition-all duration-300 ease-in-out"
                      style={{
                        height: `${15 + (i % 2) * 5}px`,
                      }}
                    ></div>
                  ))}
                </div>
              )}
            </div>

            {/* Bottom connection status */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
              <div className="flex items-center space-x-2 bg-gray-800/50 px-4 py-2 rounded-full backdrop-blur-sm">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-cyan-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
                </svg>
                <span className="text-sm font-medium text-gray-200">Secure Connection</span>
              </div>
            </div>
          </div>
        )}

        {/* User's camera feed (PiP) */}
        <div className="absolute bottom-24 right-6 w-40 h-[265px] rounded-lg overflow-hidden border border-white bg-white z-10">
          <video
            ref={mainVideoRef}
            autoPlay          
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>

        {/* Current response indicator */}
         {userResponse && (
          <div className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-white text-black p-4 rounded-lg max-w-lg">
            <p className="text-sm">{
              (() => {
                const words = userResponse.split(" ");
                return words.slice(Math.max(words.length - 3, 0)).join(" ");
              })()
            }</p>
          </div>
        )} 

        {timerRef.current.displayInitialTimer && (
          <div className="absolute top-8 left-1/2 transform -translate-x-1/2 bg-red-500/90 text-white px-6 py-3 rounded-lg shadow-xl flex items-center gap-3 backdrop-blur-sm">
            <div className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center animate-pulse">
              <span className="text-sm font-bold">{timerRef.current.initialTimer}</span>
            </div>
            <p className="text-sm font-semibold">Time remaining to start your answer</p>
          </div>
        )}
        {timerRef.current.displayStartAnswerTimer && (
          <div className="absolute top-8 left-1/2 transform -translate-x-1/2 bg-yellow-500/90 text-white px-6 py-3 rounded-lg shadow-xl flex items-center gap-3 backdrop-blur-sm">
            <div className="w-8 h-8 rounded-full border-2 border-white flex items-center justify-center animate-pulse">
              <span className="text-sm font-bold">{timerRef.current.startAnswerTimer}</span>
            </div>
            <p className="text-sm font-semibold">Auto-submitting in {timerRef.current.startAnswerTimer} seconds</p>
          </div>
        )}

        {submitAnswerVisibleRef.current.submitAnswerVisible && (
          <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 bg-white text-black px-8 py-4 rounded-full flex items-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer" onClick={() => {
            console.log("STOPPING RECOGNITION FROM SUBMIT ANSWER");
            recognitionRef.current?.stop();
          }}>
            <p className="text-sm font-medium tracking-wide">Submit Answer</p>
          </div>
        )}

        {answerTwoMinutesTimerRef.current.displayAnswerTwoMinutesTimer && (
          <div className="absolute top-4 left-4 bg-white text-black px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 backdrop-blur-sm border border-gray-100">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium">{answerTwoMinutesTimerRef.current.answerTwoMinutesTimer}s</span>
          </div>
        )}

      </div>
      
      {/* Transcripts sidebar - hidden on mobile */}
      <div className="hidden md:flex w-96 h-full bg-white text-black shadow-xl overflow-hidden flex-col border-l border-gray-100">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-cyan-50 to-gray-50">
          <div className="flex items-center space-x-3">
            <div className="h-8 w-8 rounded-full bg-cyan-600/10 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-cyan-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
              </svg>
            </div>
            <h2 className="font-semibold text-gray-800">Transcripts</h2>
          </div>
        </div>

        {/* Transcripts container */}
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4 bg-gradient-to-br from-cyan-50 to-gray-100">
          {allTranscripts.current.map((transcript, index) => (
            <div 
              key={index} 
              className={`flex ${transcript.role === "ASSISTANT" ? "justify-start" : "justify-end"} animate-fadeIn`}
            >
              <div 
                className={`
                  relative group max-w-[85%] rounded-2xl p-4 shadow-sm
                  ${transcript.role === "ASSISTANT" 
                    ? "bg-white/80 backdrop-blur-sm border border-gray-100" 
                    : "bg-cyan-600 shadow-lg"}
                `}
              >
                {transcript.role === "ASSISTANT" && (
                  <div className="absolute -left-2 top-4 w-4 h-4 bg-white border-l border-t border-gray-100 transform rotate-45" />
                )}
                {transcript.role === "USER" && (
                  <div className="absolute -right-2 top-4 w-4 h-4 bg-cyan-600 transform rotate-45" />
                )}
                <p className={`text-sm ${transcript.role === "ASSISTANT" ? "text-gray-700" : "text-white"}`}>
                  {transcript.content}
                </p>
                <div className={`absolute -bottom-4 ${transcript.role === "ASSISTANT" ? "left-4" : "right-4"} text-[10px] opacity-0 group-hover:opacity-70 transition-opacity text-gray-400`}>
                  {new Date().toLocaleTimeString()}
                </div>
              </div>
            </div>
          ))}

          {submitAnswerLoading && (
            <div className="flex justify-start animate-fadeIn">
              <div className="relative bg-white/80 backdrop-blur-sm border border-gray-100 p-4 rounded-2xl max-w-[85%] shadow-sm">
                <div className="absolute -left-2 top-4 w-4 h-4 bg-white border-l border-t border-gray-100 transform rotate-45" />
                <div className="flex items-center space-x-3">
                  <div className="relative w-8 h-8">
                    <div className="absolute inset-0 rounded-full border-2 border-cyan-500/20 animate-ping"></div>
                    <div className="absolute inset-1 rounded-full border-2 border-cyan-400/30 animate-pulse"></div>
                    <div className="relative w-full h-full rounded-full bg-cyan-600 flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0012 18.75c-1.03 0-1.96-.417-2.634-1.09l-.548.547z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-gray-600 font-medium">Processing response...</p>
                    <div className="flex space-x-1.5 mt-2">
                      <div className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                      <div className="w-1.5 h-1.5 bg-cyan-500 rounded-full animate-bounce" style={{ animationDelay: '200ms' }}></div>
                      <div className="w-1.5 h-1.5 bg-cyan-600 rounded-full animate-bounce" style={{ animationDelay: '400ms' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div ref={transcriptsEndRef} className="h-4" />
        </div>
      </div>
    </div>
  );
  }

  

  

  export default OneToOneMeeting;